module.exports = __webpack_public_path__ + "img/8_4.bce0580e.png";